import Alpine from "alpinejs"
import Swiper from "swiper"
import { Navigation } from "swiper/modules"

Alpine.data('TestimonialCarousel', () => ({
    init(){
        const swiper = new Swiper('.testimonialCarousel', {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 32,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                disabledClass: 'is-disabled'
            },
        });

    }
}))